import { createRoleDefinition, createFullAccessRole } from "./role.helpers";
import { UserRole, AccountStatus, PostStatus } from "./types";
import { PERMISSIONS } from "./permissions";

// =====================================================
// ROLE DEFINITIONS (Dynamic)
// =====================================================

export const ROLE_DEFINITIONS = {
  // Guest role: minimal access
  guest: createRoleDefinition(["profiles"], [], {
    canServe: ["user"] as UserRole[],
  }),

  // Basic User: standard matchmaking
  user: createRoleDefinition(["profiles", "reactions", "conversations", "messages"], [], {
    canServe: ["guest", "user"] as UserRole[],
  }),

  // Writer: can manage content (profiles, posts)
  writer: createRoleDefinition(["profiles", "messages"], [], {
    canServe: ["user", "writer"] as UserRole[],
    canSetPostStatuses: ["draft", "review"] as PostStatus[],
  }),

  // Reviewer: can review posts, moderate profiles
  reviewer: createRoleDefinition(["profiles", "reactions", "messages"], [], {
    canServe: ["user", "writer"] as UserRole[],
    canSetPostStatuses: ["review", "recheck"] as PostStatus[],
  }),

  // Editor: can approve posts and moderate more
  editor: createRoleDefinition(["profiles", "reactions", "messages", "bookings"], [], {
    canServe: ["user", "writer", "reviewer"] as UserRole[],
    canSetPostStatuses: ["approved", "rejected"] as PostStatus[],
  }),

  // Admin: full app access except developer tools
  admin: createFullAccessRole({
    canAssignRoles: ["guest", "user", "writer", "reviewer", "editor", "admin"] as UserRole[],
    canSetUserAccountStatuses: ["pending", "verified", "suspended", "deleted"] as AccountStatus[],
  }),

  // SuperAdmin: full access including all roles
  superadmin: createFullAccessRole({
    canAssignRoles: ["guest", "user", "writer", "reviewer", "editor", "admin", "superadmin"] as UserRole[],
    canSetUserAccountStatuses: ["pending", "verified", "suspended", "deleted"] as AccountStatus[],
  }),

  // Developer: full access + dev-only permissions
  developer: createFullAccessRole({
    canAssignRoles: ["guest", "user", "writer", "reviewer", "editor", "admin", "superadmin", "developer"] as UserRole[],
    canSetUserAccountStatuses: ["pending", "verified", "suspended", "deleted"] as AccountStatus[],
  }),
};